import { extendTheme } from '@chakra-ui/react';
import colors from './colors';

const timetimeTheme = extendTheme({
	fonts: { heading: `"Inter Variable", sans-serif`, body: `"Inter Variable", sans-serif` },
	styles: {
		global: {
			body: {
				bg: '#f9f9fa',
			},
			'nav a.active': {
				bg: 'gray.100',
				color: 'black',
			},
		},
	},
	colors: {
		...colors,
		primary: colors.pink,
		wine: {
			50: '#FAF5F0',
			100: '#F4EBE1',
			200: '#EAD8C2',
			300: '#DFC4A4',
			400: '#D5B086',
			500: '#CB9E69',
			600: '#B67E3F',
			700: '#885F2F',
			800: '#5B3F20',
			900: '#2D2010',
			950: '#171008',
		},
		zinc: {
			'50': '#f6f6f7',
			'100': '#efeff0',
			'200': '#e1e2e4',
			'300': '#cecfd3',
			'400': '#b9bac0',
			'500': '#a1a1aa',
			'600': '#91919a',
			'700': '#7d7d85',
			'800': '#66666d',
			'900': '#55555a',
			'950': '#323234',
		},
		oller: {},
	},
});

export default timetimeTheme;
